export default __webpack_public_path__ + "static/iPhone-fashion-chatbot3-c7cde3ce7328c2f323317e3493e7227c.mp4";